<div class="dropdown-backdrop d-flex justify-content-center" *ngIf="showSpinner">
  <p-progressSpinner class="spinner-overlay" strokeWidth="3"></p-progressSpinner>
</div>